module.exports = __webpack_public_path__ + "img/head_img.32ac8d0c.jpg";